import { render, staticRenderFns } from "./AdminBreak.vue?vue&type=template&id=fe1af1f4&"
import script from "./AdminBreak.vue?vue&type=script&lang=js&"
export * from "./AdminBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports